import "@/App.css";
import { motion } from "framer-motion";
import logo from "@/assets/logo.png";

const EASE = [0.16, 1, 0.3, 1];

export default function App() {
  return (
    <div
      data-testid="coming-soon-page"
      className="relative flex min-h-screen flex-col items-center justify-center bg-white px-6 text-ink"
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_45%,rgba(121,40,202,0.05),transparent_70%)]" />

      <main className="relative z-10 flex flex-col items-center text-center">
        <motion.img
          data-testid="brand-logo"
          src={logo}
          alt="DON'T EAT IT!"
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE }}
          className="w-[min(78vw,460px)]"
        />

        <motion.p
          data-testid="brand-motto"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.35 }}
          className="mt-10 font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 md:text-sm"
        >
          Tastes like s!@#. But smells great.
        </motion.p>

        <motion.span
          data-testid="launch-badge"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.55 }}
          className="mt-9 flex items-center gap-2.5 rounded-full border border-zinc-200 bg-white px-5 py-2.5 font-mono text-[10px] tracking-[0.3em] text-zinc-800 shadow-sm md:text-xs"
        >
          <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-neon" />
          COMING 2027
        </motion.span>
      </main>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.9 }}
        className="absolute bottom-8 font-mono text-[10px] tracking-[0.25em] text-zinc-400"
      >
        © 2027 DON'T EAT IT!
      </motion.p>
    </div>
  );
}